(() => {
  if (customElements.get('koppa-cart-welcome')) return;
  const code = 'KOPPAFIRST10';
  const state = {busy:false, received:false, email:'', expanded:false, message:null};
  try { state.received = sessionStorage.getItem('koppaCartWelcomeRequested') === '1'; } catch (_) {}
  const paint = () => document.querySelectorAll('koppa-cart-welcome').forEach(element => element.render());
  const request = async (url, options = {}) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, {...options, signal:controller.signal});
      if (!response.ok) throw new Error('request_failed');
      return response;
    } finally { clearTimeout(timeout); }
  };
  const cart = async () => (await request((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin'})).json();
  const hasOtherSaving = value => Number(value.total_discount) > window.KoppaCartConversion.savings(value, code) || window.KoppaCartConversion.savedCodes(value).some(value => value !== code);
  class Welcome extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.copy = JSON.parse(this.querySelector('[data-welcome-copy]').textContent);
      this.input = this.querySelector('input');
      this.form = this.querySelector('form');
      this.details = this.querySelector('details');
      this.status = this.querySelector('[role="status"]');
      this.row = this.querySelector('summary span').textContent;
      this.input.value = state.email;
      this.input.addEventListener('input', () => { state.email = this.input.value; this.input.removeAttribute('aria-invalid'); }, options);
      this.form.addEventListener('submit', event => { event.preventDefault(); event.stopPropagation(); this.submit(); }, options);
      this.querySelector('[data-welcome-retry]').addEventListener('click', () => this.submit(), options);
      this.details.open = state.expanded || matchMedia('(min-width:990px)').matches || Number(this.dataset.saving) > 0;
      this.details.addEventListener('toggle', () => { if (!matchMedia('(min-width:990px)').matches) state.expanded = this.details.open; }, options);
      this.hidden = !window.KoppaCartConversion;
      this.render();
    }
    render() {
      const saving = Number(this.dataset.saving);
      const applied = saving > 0;
      this.querySelector('summary span').textContent = applied ? this.copy.applied : this.row;
      this.querySelector('[data-welcome-signup]').hidden = state.received || applied;
      this.querySelector('[data-welcome-received]').hidden = !state.received;
      this.querySelector('[data-welcome-retry]').hidden = state.busy || applied || !state.received;
      this.input.disabled = state.busy;
      this.form.querySelector('button').disabled = state.busy;
      this.form.querySelector('button').textContent = state.busy ? this.copy.busy : this.copy.submit;
      let message = state.busy ? this.copy.busy : this.copy[state.message] || '';
      if (applied && !state.busy) {
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(saving / 100);
        message = this.copy.applied + '\n' + this.copy.saved.replace('[amount]', amount);
        this.details.open = true;
      }
      this.status.textContent = message;
    }
    async submit() {
      if (state.busy || !window.KoppaCartConversion) return;
      if (!state.received && (!this.input.validity.valid || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.input.value.trim()))) {
        state.message = 'invalid'; this.render(); this.input.setAttribute('aria-invalid','true'); this.input.focus(); return;
      }
      state.email = this.input.value.trim(); state.busy = true; state.message = null; state.expanded = true; paint();
      let changed = false;
      try {
        const before = await cart();
        if (!before.item_count || before.items.every(item => item.selling_plan_allocation)) { state.message = 'ineligible'; return; }
        if (hasOtherSaving(before)) { state.message = 'better'; return; }
        if (!state.received) {
          await request('https://a.klaviyo.com/client/subscriptions/?company_id=XVHRc2', {
            method:'POST', headers:{'Content-Type':'application/json', revision:'2024-10-15'},
            body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Cart — 10% first order',profile:{data:{type:'profile',attributes:{email:state.email,properties:{koppa_cart_welcome_code:code}}}}},relationships:{list:{data:{type:'list',id:'Usdkyg'}}}}})
          });
          state.received = true;
          try { sessionStorage.setItem('koppaCartWelcomeRequested','1'); } catch (_) {}
          document.dispatchEvent(new CustomEvent('koppa:form-result',{detail:{form_id:'koppa-cart-welcome',kind:'newsletter',status:'submitted','signup location':'cart welcome'}}));
        }
        const result = await window.KoppaCartConversion.updateDiscount(code, {source:'cart', preserveExisting:true});
        changed = true;
        state.message = result.state === 'applied' ? null : ['better','ineligible','subscription'].includes(result.state) ? (result.state === 'subscription' ? 'ineligible' : result.state) : 'pending';
        document.querySelectorAll('koppa-cart-welcome').forEach(element => { element.dataset.saving = result.amount; element.dataset.currency = result.cart.currency; });
      } catch (_) { state.message = 'error'; }
      finally {
        state.busy = false; paint();
        if (changed) { try { await window.KoppaCartConversion.refresh(); } catch (_) {} }
      }
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('koppa-cart-welcome', Welcome);
})();
